module.exports = __webpack_public_path__ + "assets/b846621efa8744606837dad04b0db724.mp3";